let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fjW4r")).then(() => parcelRequire('1aBcD'));